import { Injectable } from '@angular/core';
import { setProps } from '@ngneat/elf';
import { ShopOffersInventory } from '@app/shared/models/inventory.model';
import { ShopOffersItem } from '@app/shared/models/shop-offers.model';
import { shopRatesStore, shopRates$, coinRates$, gemRates$ } from './shop-rates.store';

@Injectable({ providedIn: 'root' })
export class ShopRatesRepository {
  readonly shopRates$ = shopRates$;
  readonly coinRates$ = coinRates$;
  readonly gemRates$ = gemRates$;

  setShopRates(shopRates: ShopOffersInventory): void {
    shopRatesStore.update(setProps(shopRates));
  }

  reset(): void {
    shopRatesStore.reset();
  }

  getShopRates(): ShopOffersInventory {
    return shopRatesStore.getValue();
  }

  getCoinRates(): ShopOffersItem[] {
    return this.getShopRates()?.Coins ?? [];
  }

  getGemRates(): ShopOffersItem[] {
    return this.getShopRates()?.Gems ?? [];
  }

  getAllSkus(): string[] {
    return this.getCoinSkus().concat(this.getGemsSkus());
  }

  getCoinSkus(): string[] {
    return this.getCoinRates().map((item) => item.sku);
  }

  getGemsSkus(): string[] {
    return this.getGemRates().map((item) => item.sku);
  }

  getShopItemBySku(sku: string, coins = true): ShopOffersItem {
    const itemsToSearch = coins ? this.getCoinRates() : this.getGemRates();
    return this.findBySku(itemsToSearch, sku);
  }

  private findBySku(items: ShopOffersItem[], sku: string): ShopOffersItem {
    return items.find((shopItem: ShopOffersItem) => shopItem.sku === sku);
  }
}
